import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-call_request-view';
/**
 * Call request modal pop up view in help center self serve flow
 */
export function trackHelpCenterCallRequestView(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
